// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"214":"c8811305","300":"4c6520b8","307":"726e7e19","308":"00c3d1d8","318":"ce882c00","476":"ae48b39b","537":"c3bd4d62","640":"a65c8b23","696":"45f78a83","726":"2a8eeebf","848":"7fece124","923":"c9217c07"}[chunkId] + ".js";
};